import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CtwrPartService } from '../../../../ctwr.service';
import { FilterableService } from '../../../../../mesc/filterable-service';
import { HttpParams } from '@angular/common/http';
import { CgpAlertDialogService } from '../../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { SortableComponent } from '@progress/kendo-angular-sortable';

@Component({
  selector: 'part-ownership',
  templateUrl: './part-ownership.component.html',
  styleUrls: ['./part-ownership.component.scss']
})
export class PartOwnershipComponent implements OnInit {
  @Input() show: boolean;
  @Input() set parts(data: any[]) {
    this.availableParts = data;
  }
  @Input() set ptes(data: any[]) {
    this.fromPTEService.next(data);
  }
  @Output() close: EventEmitter<any> = new EventEmitter<any>();

  fromPTE: any;
  toPTE: any;
  fromPTEService: FilterableService = new FilterableService();
  toPTEService: FilterableService = new FilterableService();
  fromPTE1Parts = [];
  fromPTE2Parts = [];
  toPTE1Parts = [];
  toPTE2Parts = [];
  availableParts: any[];

  @Output()
  transfer: EventEmitter<any> = new EventEmitter<any>();

  sortableStyles = {
    empty: {
      'width': '100%',
      'line-height': '4em',
      'text-align': 'center',
      'border-radius': '4px',
      'border': '1px dashed #ccc',
      'background': '#fafafa',
    },
    active: {
      'border': '1px dashed #538FE3',
      'border-radius': '4px',
      'background-color': '#538FE3',
      'color': '#fff'
    },
  }

  constructor(
    private readonly partService: CtwrPartService,
    private readonly alertDialog: CgpAlertDialogService,
  ) {
  }

  ngOnInit() { }


  /**
   * 
   */
  save = () => {
    let params: HttpParams = new HttpParams()
      .set('newPTEUserId', this.toPTE.Id)
    let partIds = this.toPTE1Parts.map(p => p.Id);
    partIds.forEach(p => params = params.append('PTE1PartIds', p));

    partIds = this.toPTE2Parts.map(p => p.Id);
    partIds.forEach(p => params = params.append('PTE2PartIds', p));

    const _path = `/TransferPartPTE?${params.toString()}`;
    this.partService.save({}, true, _path)
      .then(x => this.handlePartsTransferred());
  }


  /**
   * 
   */
  fromPTEChange = (dataItem) => {
    this.resetView();
    this.fromPTE = dataItem;
    if (dataItem) {
      this.partService.read(`/user/${dataItem.Id}`)
        .then(x => {
          this.fromPTE1Parts = (this.availableParts.filter(p => x.PTE1PartIds.some(i => i === p.Id)));
          this.fromPTE2Parts = (this.availableParts.filter(p => x.PTE2PartIds.some(i => i === p.Id)));
        });
      this.toPTEService.next(this.fromPTEService.value.filter(u => u.Id !== dataItem.Id));
    }
  }


  /**
   * 
   */
  toPTEChange = (dataItem) => {
    this.toPTE = dataItem;
  }


  /**
   * 
   * @param fromPartService 
   * @param toPartService 
   */
  moveAllParts(sortableA: SortableComponent, sortableB: SortableComponent) {
    const isFromSource = sortableB._data.length === 0;
    const source = isFromSource ? sortableA : sortableB;
    const target = isFromSource ? sortableB : sortableA;

    source._data.forEach((p, i) => {
      target.addDataItem(p, 0);
      source.removeDataItem(i);
    });
  }


  /**
   * 
   */
  handleClose() {
    this.resetView();
    this.close.emit();
  }


  /**
   * 
   */
  private resetView() {
    this.fromPTE1Parts = [];
    this.toPTE1Parts = [];
    this.fromPTE2Parts = [];
    this.toPTE2Parts = [];
    this.toPTE = undefined;
    this.fromPTE = undefined;
  }


  /**
   * 
   */
  private handlePartsTransferred() {
    const total = this.toPTE1Parts.length + this.toPTE2Parts.length;
    this.alertDialog.showAlertDialog({
      title: 'Transfer Success',
      message: `Transferred ${total} part(s).`,
      alert: 'success',
      closeLabel: 'OK',
    });
    this.transfer.emit();
    this.resetView();
  }

  /**
   * 
   */
  public get CanTransfer(): boolean {
    return !this.fromPTE ||
      !this.toPTE ||
      (this.toPTE1Parts.length === 0 && this.toPTE2Parts.length === 0);
  }

}
